var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.33398V13.084C16.5 15.334 15 16.834 12.75 16.834H5.25C3 16.834 1.5 15.334 1.5 13.084V9.33398C1.5 7.29398 2.73 5.86898 4.6425 5.62898C4.8375 5.59898 5.04 5.58398 5.25 5.58398H12.75C12.945 5.58398 13.1325 5.59148 13.3125 5.62148C15.2475 5.84648 16.5 7.27898 16.5 9.33398Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3145 5.62148C13.1345 5.59148 12.947 5.58399 12.752 5.58399H5.25203C5.04203 5.58399 4.83953 5.59899 4.64453 5.62899C4.74953 5.41899 4.89953 5.22399 5.07953 5.04399L7.51703 2.59898C8.54453 1.57898 10.2095 1.57898 11.237 2.59898L12.5495 3.9265C13.0295 4.399 13.2845 4.99898 13.3145 5.62148Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.70898H14.25C13.425 9.70898 12.75 10.384 12.75 11.209C12.75 12.034 13.425 12.709 14.25 12.709H16.5",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.e88d5c636d7e55420d347db7194dd6e6.svg";
export { ForwardRef as ReactComponent };